var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconMoreComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'arco';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-more").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 16 16", fill: useCurrentColor ? 'currentColor' : '#000', xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("path", { d: "M1.66675 7.99996C1.66675 7.26358 2.2637 6.66663 3.00008 6.66663C3.73646 6.66663 4.33341 7.26358 4.33341 7.99996C4.33341 8.73634 3.73646 9.33329 3.00008 9.33329C2.2637 9.33329 1.66675 8.73634 1.66675 7.99996ZM6.66675 7.99996C6.66675 7.26358 7.2637 6.66663 8.00008 6.66663C8.73646 6.66663 9.33342 7.26358 9.33342 7.99996C9.33342 8.73634 8.73646 9.33329 8.00008 9.33329C7.2637 9.33329 6.66675 8.73634 6.66675 7.99996ZM11.6667 7.99996C11.6667 7.26358 12.2637 6.66663 13.0001 6.66663C13.7365 6.66663 14.3334 7.26358 14.3334 7.99996C14.3334 8.73634 13.7365 9.33329 13.0001 9.33329C12.2637 9.33329 11.6667 8.73634 11.6667 7.99996Z", fillOpacity: "1" }));
}
var IconMore = React.forwardRef(IconMoreComponent);
export default IconMore;
